import script from "./NutritionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./NutritionInfo.vue?vue&type=script&setup=true&lang=js"

import "./NutritionInfo.vue?vue&type=style&index=0&id=de7a87d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de7a87d8"]])

export default __exports__